module.exports = __webpack_public_path__ + "img/1440.8ff5408a.jpg";